import type { TitleBrief } from "@anisync/types";
import { stagger } from "../lib/motion";
import { TitleCard, TitleCardSkeleton } from "./title-card";

/** Stałe klucze zastępczych kafli — indeks tablicy nie nadaje się na klucz. */
const SKELETON_KEYS = ["s1", "s2", "s3", "s4", "s5", "s6"] as const;

/**
 * Poziomy pas kafli.
 *
 * Przewijanie jest natywne i zachowuje punkty zaczepienia, dzięki czemu
 * klawiatura i palec działają bez dodatkowej logiki — pełną nawigację kierunkową
 * dla pilota dołoży dopiero etap interfejsu telewizyjnego.
 *
 * Pas **wychodzi za margines strony** (`bleed`), a nie kończy się razem
 * z treścią: ucięty w połowie kafel na krawędzi okna jest jedyną informacją, że
 * dalej coś jest. Odstęp bierzemy ze zmiennej, nie z liczby — wcześniej było tu
 * wpisane `-mx-6 px-6`, więc na telefonie pas wychodził za daleko i pierwszy
 * kafel był obcięty od lewej.
 */
export function Rail({
  heading,
  titles,
  loading = false,
  emptyMessage,
}: {
  heading: string;
  titles: TitleBrief[];
  loading?: boolean;
  emptyMessage?: string;
}) {
  const showEmpty = !loading && titles.length === 0;

  return (
    <section className="min-w-0">
      <h2 className="mb-3 px-1 text-sm font-semibold tracking-wide text-muted-foreground uppercase">
        {heading}
      </h2>

      {showEmpty ? (
        <p className="px-1 text-sm text-muted-foreground">
          {emptyMessage ?? "Nic tu jeszcze nie ma."}
        </p>
      ) : (
        <div className="rail-scroll bleed pb-2">
          <div className="flex gap-4">
            {loading
              ? SKELETON_KEYS.map((k) => <TitleCardSkeleton key={k} />)
              : titles.map((t, i) => (
                  <div key={t.id} className="enter-rise snap-start" style={stagger(i)}>
                    <TitleCard title={t} />
                  </div>
                ))}
          </div>
        </div>
      )}
    </section>
  );
}
